<template>
  <StdPageContainer type="create">
    <template slot="title">
      <!-- NOTE: 标题栏: 开发人员根据业务调整 -->
      <StdPageTitle :title="!$route.query.id ? '创建' : '编辑'"></StdPageTitle>
    </template>

    <template slot="content">
      <begin-play :webinarId="$route.params.id"></begin-play>
      <MallRewardEdit
        @save="toList"
        :webinarId="$route.params.id"
        :type="$route.query.type"
        :mallRewardId="$route.query.id"
      ></MallRewardEdit>
    </template>
  </StdPageContainer>
</template>
<script>
  import { StdPageContainer, StdPageTitle } from '@vhcl/ui-console';
  import { MallRewardEdit } from '@vhcl/mall-rewards';
  import beginPlay from '@/components/beginBtn';
  export default {
    components: {
      StdPageContainer,
      StdPageTitle,
      MallRewardEdit,
      beginPlay
    },
    methods: {
      toList() {
        this.$router.push({
          path: `/live/MallRewards/${this.$route.params.id}`,
          query: { tab: this.$route.query.type }
        });
      }
    }
  };
</script>
